import { FC } from 'react';
import { css, useTheme } from '@emotion/react';
import { Copy, Question } from '@phosphor-icons/react';
import { Banner } from 'client/components/Banner';
import { Button } from 'client/components/Button';
import { Dialog } from 'client/components/Dialog/Dialog';
import { Typography } from 'client/components/Typography';

const bannerStyle = css`
  margin-top: 1.5rem;
`;

export interface CloneDialogProps {
  open: boolean;
  disabled: boolean;
  onClone: () => void;
  onClose: () => void;
}

export const CloneDialog: FC<CloneDialogProps> = ({ open, disabled, onClone, onClose }) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      title="Clone this deployment?"
      description="Confirm the cloning of the deployment"
      icon={<Copy color={theme.color.primary[100]} />}
      iconOrnament={<Question color={theme.color.primary[100]} />}
      actions={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button primary icon={<Copy />} autoFocus onClick={onClone}>
            Clone Deployment
          </Button>
        </>
      }
      onClose={onClose}
    >
      <Typography variant="body1">
        You are about to clone this deployment. This will copy everything (including files & data) into a new deployment.
        <br />
        You will get to edit details of the new deployment before it is created.
      </Typography>
      <Banner css={bannerStyle}>Editing certain aspects of this deployment will be unavailable while it is being cloned.</Banner>
      {!disabled && (
        <Banner type="warning" css={bannerStyle}>
          Looks like this deployment is still running. It is highly recommended to disable a deployment before cloning it. Cloning a running
          deployment may result in incomplete datatransfer.
        </Banner>
      )}
    </Dialog>
  );
};
